import { all } from 'redux-saga/effects';
import AuthSaga from './AuthSaga';
import ManagerSaga from './ManagerSaga';
import SurveySaga from './SurveySaga';
import SolutionsSaga from './SolutionsSaga';
import ResourcesSaga from './ResourcesSaga';
import OnboardingSaga from './OnboardingSaga';

export function* sagas() {
  yield all([AuthSaga, ManagerSaga, SurveySaga, SolutionsSaga, ResourcesSaga, OnboardingSaga]);
}
